import AsyncControlFactory from '@/Factories/AsyncControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import PropertyGroupBoxViewModel from '@/ViewModels/Controls/PropertyGroupBoxViewModel';
import PropertyGroupBox from '@/Controls/PropertyGroupBox';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class DataTypeEmptyGroupBoxFactory extends AsyncControlFactory {

    private jQueryControl: JQuery;
    private PropertyGroupBoxViewModel = ComponentManager.getViewModel<typeof PropertyGroupBoxViewModel>('PropertyGroupBoxViewModel');
    private PropertyGroupBox = ComponentManager.getControl<typeof PropertyGroupBox>('PropertyGroupBox')
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: PropertyGroupBoxViewModel;

    public constructor(private params: any) {
        super(params);
        this.layout = this.paramOrDefault(this.params.layout, 'NoneLayout');
    }

    /**
     * @override
     */
    control: PropertyGroupBox;

    public async getElementAsync(): Promise<JQuery> {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        
        this.viewModel = this.createViewModel();

        this.control = new this.PropertyGroupBox(this.viewModel);

        this.defineComputed(() => {
            this.isValid(this.viewModel.isValid());
        });

        let tuple = await this.control.getTupleAsync();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    private createViewModel(): PropertyGroupBoxViewModel {
        let items = [];

        if (this.detailViewItem.children.length === 1) {
            this.detailViewItem.children[0].ergName = this.detailViewItem.ergName;
            this.detailViewItem.children[0].length = this.detailViewItem.length;
            this.detailViewItem.children[0].tooltip = this.detailViewItem.tooltip;
            this.detailViewItem.children[0].guiReadOnly = this.detailViewItem.guiReadOnly;

            items.push(this.detailViewItem.children[0]);
        }

        return new this.PropertyGroupBoxViewModel({
            context: this.context,
            layout: this.layout,
            isValid: this.isValid,
            isEnabled: this.isEnabled,
            invalidationText: this.invalidationText,
            detailViewGroups: this.detailViewItem.detailViewGroups,
            detailViewItems: items,
            locator: this.locator,
            isSummaryViewMode: this.isSummaryViewMode,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            })
        });
    }
}

ComponentManager.setFactory('DataTypeEmptyGroupBox', DataTypeEmptyGroupBoxFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');